import { urlBaseLeadCollector } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

export default async function saveStand(
  eventId = '',
  groupName = '',
) {
  try {
    const _config = {
      method: 'POST',
      url: `${urlBaseLeadCollector}/adminPlus/saveStand`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        adminPlusEventId: eventId,
        groupName: groupName,
      }
    };

    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return null;
  } catch (error) {
    console.log('Error saveStand', error);
    throw error;
  }
}
